import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_STORE_PAGE_NAME } from '../../../constants/service/app/recommendStoreConstants';
import RecommendStoreDetailContainer from '../../../containers/recommend/store/RecommendStoreDetailContainer';

const RecommendStoreDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_STORE_PAGE_NAME.RECOMMEND_STORE_DETAIL}>
      <RecommendStoreDetailContainer />
    </PageTemplate>
  );
};

export default RecommendStoreDetail;
